import tw from './zh-tw/index.js'
import en from './en-us/index.js'

const messages = {
  'zh-tw' : tw,
  'en-us' : en
}

export default messages
